<template>
  <div>
    <template v-if="this.data != null">
      <v-row dense>
        <v-col cols="12">
          <h2>Nastavení stanice</h2>
          <i class="text-caption">(ukládání 'při vypnutí' od verze CCU 41.45) </i>
        </v-col>
      </v-row>

      <v-row dense class="my-4">
        <v-col cols="12" md="3"> <v-text-field @focus="stopTimer" dense v-model="data.config.ident" label="Identifikátor" hint="HM08022L01000026" persistent-hint /> <br /> </v-col>
        <v-col cols="12" md="3"> <v-text-field @focus="stopTimer" dense v-model="data.config.objectIdent" label="Identifikátor objektu" hint="ECSKLADEC" persistent-hint /> <br /> </v-col>
        <v-col cols="12" md="3"> <v-text-field @focus="stopTimer" dense v-model="data.config.serialNumber" label="Sériové číslo" hint="HM08022L01000026" persistent-hint /> <br /> </v-col>
        <v-col cols="12" md="3"> <v-text-field @focus="stopTimer" dense v-model="data.config.httpServerPort" label="HTTP PORT" hint="0...65535" persistent-hint /> <br /> </v-col>
        <v-col cols="12" md="3"> <v-text-field @focus="stopTimer" dense v-model="data.config.restServiceUrl" label="URL spojení se serverem" hint="https://ecccu.energycloud.cz" persistent-hint /> <br /> </v-col>
        <v-col cols="12" md="3"> <v-text-field @focus="stopTimer" dense v-model="data.config.restServicePeriodMS" label="Perioda dotazů" hint="3000 [ms]" persistent-hint /> <br /> </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" md="5">
          <h3>Konfigurace elektroměru</h3>
          <i class="text-caption">(ukládání 'při vypnutí' od verze CCU 41.45) </i>
          <v-radio-group dense v-model="data.config.elMeterPhase">
            <v-radio @change="stopTimer" label="Interní měření - Stanice" :value="0"></v-radio>
            <v-radio @change="stopTimer" label="Externí měření - Fáze 1" :value="1"></v-radio>
            <v-radio @change="stopTimer" label="Externí měření - Fáze 2" :value="2"></v-radio>
            <v-radio @change="stopTimer" label="Externí měření - Fáze 3" :value="3"></v-radio>
            <v-radio @change="stopTimer" label="Externí měření - Všechny 3 fáze" :value="4"></v-radio>
          </v-radio-group>

          <v-row no-gutters>
            <v-col cols="12">
              <h3>Typ elektroměru</h3>
              <i class="text-caption">(funkční od verze CCU 41.35) </i>
              <v-radio-group dense v-model="data.elMeterType" @change="changeElMeterType">
                <v-radio @change="stopTimer" label="Schneider (default addr: 5)" :value="1"></v-radio>
                <v-radio @change="stopTimer" label="Phoenix EEM-EM325/355/375/327/357/377 (default addr: 5)" :value="2"></v-radio>
                <v-radio @change="stopTimer" label="Phoenix EEM-EM357-EE (default addr: 1)" :value="3"></v-radio>
                <v-radio @change="stopTimer" label="Solax G4 X3 ELM (default addr: 1)" :value="4"></v-radio>
                <v-radio @change="stopTimer" label="EnergyCloud ELM (default addr: 1)" :value="5"></v-radio>
              </v-radio-group>
            </v-col>

            <v-row dense>
              <v-col cols="8" md="6">
                <h5>Modbus adresa elektroměru</h5>
                <i class="text-caption">&nbsp;</i>
                <v-text-field @focus="stopTimer" dense v-model="elMeterModbusAddrCurrent" label="" persistent-hint />
              </v-col>

              <v-col cols="8" md="6">
                <h5>Modbus port</h5>
                <i class="text-caption">(funkční od verze CCU 42.12) </i>
                <v-text-field @focus="stopTimer" dense v-model="elMeterModbusIpPort" label="" persistent-hint />
              </v-col>
            </v-row>
          </v-row>
        </v-col>

        <v-col cols="12" md="7">
          <v-row dense>
            <v-col cols="12">
              <h3>Nastavení elektroměru</h3>
              <p>
                Při změně IP adresy dojde k restartování aplikace
                <br />
                Legenda: &nbsp;
                <v-avatar color="green" size="16"></v-avatar> Komunikuje &nbsp;<v-avatar color="red" size="16"></v-avatar> Nekomunikuje
              </p>
            </v-col>

            <v-col cols="12" v-for="(item, index) in filteredItems" :key="index">
              <template v-if="item.nId != null">
                <v-row dense :style="getCommStyle(item)" class="text-overline">
                  <v-col cols="12" sm="8">
                    <i> ID: {{ item.nId }} - {{ item.sName }} - {{ item.sSerialNo }} - {{ item.uModbusAddr }} - {{ item.uModbusIpPort }} </i>
                  </v-col>

                  <v-col cols="3" sm="1"> <v-text-field @focus="stopTimer" dense v-model="item.ip4" label="" persistent-hint suffix="." /> </v-col>
                  <v-col cols="3" sm="1"> <v-text-field @focus="stopTimer" dense v-model="item.ip3" label="" persistent-hint suffix="." /> </v-col>
                  <v-col cols="3" sm="1"> <v-text-field @focus="stopTimer" dense v-model="item.ip2" label="" persistent-hint suffix="." /></v-col>
                  <v-col cols="3" sm="1"> <v-text-field @focus="stopTimer" dense v-model="item.ip1" label="" persistent-hint /></v-col>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12"><v-btn color="primary" elevation="6" @click="sendConfig"> Nastavit </v-btn></v-col>
      </v-row>
    </template>
    <template v-else>
      <LoadingData />
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LoadingData from "../LoadingData.vue";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "StationConfig",
  props: {},
  components: {
    LoadingData,
  },
  data() {
    return {
      timer: null,
      mobile: false,

      data: null,

      elMeterModbusAddrCurrent: 0,
      elMeterModbusIpPort: 0,
      elMeterCurrent: "",

      elMeter: [
        { serialNumber: "XELMS1MK00001001", value: 1 }, //
        { serialNumber: "XELMS2MK00001001", value: 2 }, //
        { serialNumber: "XELMS3MK00001001", value: 3 }, //
        { serialNumber: "XELMS4MK00001001", value: 4 }, //
        { serialNumber: "XELMS5MK00001001", value: 5 }, //
      ],

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
  },
  created() {
    this.getBreakpoints();
    this.getData();
  },
  mounted() {
    this.pollData();

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    filteredItems() {
      return this.data.units.filter((item) => item.uAddr === "ee90");
    },
  },
  methods: {
    getCommStyle(item) {
      if (parseInt(item.uDiagCode) == 1) {
        return "color: green";
      } else {
        return "color: red";
      }
    },
    stopTimer() {
      if (this.timer != null) {
        clearInterval(this.timer);

        this.timer = null;
      }
    },
    refreshTimer() {
      if (this.timer == null) {
        this.pollData();
      }
    },
    sendConfig() {
      let formData = "";

      formData = ServiceClient.insertAnotherParameter(formData);
      formData += "ident" in this.data.config ? "sIdent=" + this.data.config.ident : "";
      formData = ServiceClient.insertAnotherParameter(formData);
      formData += "objectIdent" in this.data.config ? "sObjectIdent=" + this.data.config.objectIdent : "";
      formData = ServiceClient.insertAnotherParameter(formData);
      formData += "serialNumber" in this.data.config ? "sSerialNo=" + this.data.config.serialNumber : "";
      formData = ServiceClient.insertAnotherParameter(formData);
      formData += "elMeterPhase" in this.data.config ? "u16ElMeterPhase=" + this.data.config.elMeterPhase : "";
      formData = ServiceClient.insertAnotherParameter(formData);
      formData += "httpServerPort" in this.data.config ? "u16HttpPort=" + this.data.config.httpServerPort : "";
      formData = ServiceClient.insertAnotherParameter(formData);
      formData += "restServiceUrl" in this.data.config ? "sAppRestServiceUrl=" + this.data.config.restServiceUrl : "";
      formData = ServiceClient.insertAnotherParameter(formData);
      formData += "restServicePeriodMS" in this.data.config ? "u16AppRestServiceRequestPeriodMS=" + this.data.config.restServicePeriodMS : "";

      for (let index = 0; index < this.data.units.length; index++) {
        if (this.data.units[index].uAddr == "ee90") {
          formData = ServiceClient.insertAnotherParameter(formData);
          formData += this.elMeterCurrent != "" ? "setSerialNumber=" + this.elMeterCurrent : "";
          formData = ServiceClient.insertAnotherParameter(formData);
          formData += this.elMeterModbusAddrCurrent != "" ? "setModbusAddr=" + this.elMeterModbusAddrCurrent : "";
          formData = ServiceClient.insertAnotherParameter(formData);
          formData += this.elMeterModbusIpPort != "" ? "setModbusIpPort=" + this.elMeterModbusIpPort : "";
          formData = ServiceClient.insertAnotherParameter(formData);
          formData += this.data.units[index].ip1 != "" ? this.data.units[index].nId + "_ipAddr1=" + this.data.units[index].ip1 : "";
          formData = ServiceClient.insertAnotherParameter(formData);
          formData += this.data.units[index].ip2 != "" ? this.data.units[index].nId + "_ipAddr2=" + this.data.units[index].ip2 : "";
          formData = ServiceClient.insertAnotherParameter(formData);
          formData += this.data.units[index].ip3 != "" ? this.data.units[index].nId + "_ipAddr3=" + this.data.units[index].ip3 : "";
          formData = ServiceClient.insertAnotherParameter(formData);
          formData += this.data.units[index].ip4 != "" ? this.data.units[index].nId + "_ipAddr4=" + this.data.units[index].ip4 : "";
        }
      }

      ServiceClient.dataCore(ServiceClient.getAPIUrl("config"), formData, null, "POST")
        .then(() => {
          this.refreshTimer();
        })
        .catch((error) => {
          this.refreshTimer();

          ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    onResize() {
      this.getBreakpoints();
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 768) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    changeElMeterType() {
      this.elMeterCurrent = this.getELMSerialNumber(this.data.elMeterType);
    },
    getELMSerialNumber(value) {
      for (let index = 0; index < this.elMeter.length; index++) {
        if (this.elMeter[index].value == value) {
          return this.elMeter[index].serialNumber;
        }
      }
    },
    getELMValue(serialNumber) {
      for (let index = 0; index < this.elMeter.length; index++) {
        if (this.elMeter[index].serialNumber.slice(0, 7) == serialNumber.slice(0, 7)) {
          return this.elMeter[index].value;
        }
      }
    },
    pollData() {
      this.timer = setInterval(() => {
        this.getData();
      }, 2555);
    },
    getData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("config"), null, null, "GET")
        .then((data) => {
          this.data = data;
          for (let index = 0; index < this.data.units.length; index++) {
            if (this.data.units[index].uAddr == "ee90") {
              this.data.elMeterType = this.getELMValue(this.data.units[index].sSerialNo);
              this.elMeterModbusAddrCurrent = this.data.units[index].uModbusAddr;
              this.elMeterModbusIpPort = this.data.units[index].uModbusIpPort;
            }
          }
        })
        .catch((error) => {
          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);

    window.removeEventListener("resize", this.onResize);
  },
  destroyed() {},
};
</script>

<style scoped></style>
